import { render, staticRenderFns } from "./report_incident.vue?vue&type=template&id=5c2d9b0f"
import script from "./report_incident.vue?vue&type=script&lang=js"
export * from "./report_incident.vue?vue&type=script&lang=js"
import style0 from "./report_incident.vue?vue&type=style&index=0&id=5c2d9b0f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports